import { StateInterface } from "./state";
import { ManualModel } from "../models";

export const setManualsHandle = "setManuals";

export default {
  [setManualsHandle](state: StateInterface, manuals: ManualModel[]): void {
    state.manuals = manuals;
  },
};
